import { useState } from 'react';

import { type trackTileInteractionParams } from '../cards/job-card/use-job-card-tracking';
import { useSearchAndShuffleContext } from '../context';

import Styles from './tile.style';

export const Tile: React.FC<{
  label: string;
  title: string;
  isBlurred?: boolean;
  trackTileName: trackTileInteractionParams['tileName'];
  progressBar?: {
    progress: number;
    showLabel?: boolean;
    progressBarColor?: string;
  };
  PeakAndPop?: React.FC<{
    isShown: boolean;
    setIsShown: (show: boolean) => void;
    trackTileName: trackTileInteractionParams['tileName'];
  }>;
}> = ({ label, title, progressBar, PeakAndPop, trackTileName, isBlurred }) => {
  const [isPeakAndPopShown, setIsPeakAndPopShown] = useState(false);
  const { cardLinksEnabled, config } = useSearchAndShuffleContext();
  const registrationUrlFallback = '/start/signup';
  return (
    <>
      <Styles.Item
        onClick={(e) => {
          e.stopPropagation(); // Prevent job link from opening

          if (!isBlurred) {
            e.preventDefault();
            if (cardLinksEnabled.current) {
              setIsPeakAndPopShown(true);
            }
          }
        }}
        href={
          isBlurred
            ? `${config?.interrupterCards?.registrationUrl || registrationUrlFallback}`
            : undefined
        }
        data-qa={`dm-tile-${trackTileName}`}
      >
        <Styles.ItemContent>
          <Styles.ItemLabel size="small">{label}</Styles.ItemLabel>
          {progressBar && (
            <Styles.TilesProgressBar
              progress={progressBar.progress}
              showLabel={progressBar.showLabel}
              progressBarColor={progressBar.progressBarColor}
            />
          )}
          <Styles.Title
            size="medium"
            $isBlurred={isBlurred}
            fontWeight="bold"
            lineHeight="dense"
          >
            {title}
          </Styles.Title>
        </Styles.ItemContent>
      </Styles.Item>
      {PeakAndPop && (
        <PeakAndPop
          isShown={isPeakAndPopShown}
          setIsShown={setIsPeakAndPopShown}
          trackTileName={trackTileName}
        />
      )}
    </>
  );
};
